export default __webpack_public_path__ + "static/media/Patrika.1409fec1.jpg";